import styled from "styled-components";

import { IThemeProps } from "@/styles/Theme";
import { fadeIn } from "@/styles/utils/Mixins";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  height: 100%;
  width: 100%;
  text-align: center;
  background: #212529;
  font-family: ${(props: IThemeProps) => props.theme.globals.fontFamilyExtra};
  color: #ffffff;
  user-select: none;
`;

export const Header = styled.div`
  margin: 0 32px;
`;

export const Title = styled.div`
  font-family: ${(props: IThemeProps) => props.theme.globals.fontFamilyExtra2};
  line-height: 0.9;
  margin-bottom: 20px;
`;

export const TotalVotes = styled.div`
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 800;
  opacity: 0.8;
  letter-spacing: 0.5px;
`;

export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  max-width: 375px;
  padding: 0 32px;
`;

type FadeInTextProps = IThemeProps<{ $delay?: number }>;
export const FadeInText = styled.span<FadeInTextProps>`
  opacity: 0;
  animation: ${fadeIn} 150ms ease-in
    ${(props: FadeInTextProps) => props.$delay || 150}ms;
  animation-fill-mode: forwards;
`;

export const ThankYou = styled.div`
  font-family: ${(props: IThemeProps) => props.theme.globals.fontFamilyExtra2};
  width: 265px;
  height: 72px;
  margin: 15px 32px;
  font-size: 40px;
  line-height: 0.9;
  color: #fe0101;
`;
